module.exports = __webpack_public_path__ + "index_pc/img/logo.c166edfc.jpg";